/* Copyright (c) 2017 Backpack Health LLC */

import * as React from 'react';
import { HasLanguageCode, withIntl, withLanguageCode } from '../../utilities/localizedUtil';
import { ListItem } from '../../apiServices/ListsService';
import { HealthEntry } from '../../models/HealthEntry';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { selectors as listSelectors } from '../redux/ducks/lists/lists';
import DateUtil from '../../utilities/DateUtil';

export interface Props {
  intl?: any;
  healthEntry: HealthEntry;
  diagnosisList?: ListItem[];
}

@withIntl
@connect(state => ({
  diagnosisList: listSelectors.getDiagnosisList(state),
}))
export class LocalizedDiagnosis extends React.Component<Props, {}> {
  render() {
    const { diagnosisList, healthEntry, intl: { locale } } = this.props;

    const diagnosis = diagnosisText();

    function diagnosisText() {
      const d = diagnosisList.find(d => d.id === healthEntry.diagnosis.getValue());
      return d ? `list.healthEntry.diagnosis.${ d.name }.text` : '';
    }

    return (
      <span>
        {diagnosis && <FormattedMessage id={diagnosis}/>}
        {
          healthEntry.diagnosis.getDate() &&
          <span>
            {' '}
            {DateUtil.formattedMediumDate(healthEntry.diagnosis.getDate().date, healthEntry.diagnosis.getDate().precision, locale)}
          </span>
        }
      </span>
    );
  }
}

